<div id="wrapper">
  <app-loading-screen></app-loading-screen>
  <div class="allcont">
    <app-menu [tabActive]="this.tabActive"></app-menu>

    <div class="basicrow mbott">
      <div class="container">
        <div class="fulltitle m-top-i f-btitle">
          <img width="100%" class="userimgicon" src="../../assets/images/usersvicon.png"> Usuarios y Permisos
        </div>

        <div class="autowcont m-top">
          <div class="basicrow msidespad">
            <div class="b-title">
              <div class="autocont f-black roboto-m f-bmed pull-left vcenter">
                <div class="tabcell">
                  Crear Usuarios
                </div>
              </div>
            </div>
          </div>

          <div class="basicrow msidespad">
            <a class="boxlink-i" (click)="this.add()" routerLink="/userspermissions"><i class="fa fa-angle-double-right"
                aria-hidden="true"></i>Crear nuevo usuario</a>
          </div>
        </div>

        <div class="basicrow">
          <div class="basicrow m-top-i">
            <div class="basicrow f-reg f-black text-justify">
              <div class="basicrow semititle">
                Usuarios Administrativos
              </div>

              <div class="basicrow m-top-u">
                Listado de usuarios, perfiles administrativos y usuarios Mi Claro.
              </div>
            </div>

            <div class="basicrow m-top-i">
              <!-- inicio Tabla web -->
              <div class="basicrow visible-web boxtbl">
                <div class="tab-tbar">
                  <div class="frwds frsthalf rline vcenter">
                    <div class="tabcell">
                      Nombre de Empresa
                    </div>
                  </div>

                  <div class="frwds frsthalf rline vcenter">
                    <div class="tabcell">
                      Usuario/Email
                    </div>
                  </div>

                  <div class="frwds scndhalfs rline vcenter">
                    <div class="tabcell">
                      Perfil
                    </div>
                  </div>
                  <div class="frwds scndhalfs rline vcenter">
                    <div class="tabcell">
                      Fecha Creado
                    </div>
                  </div>

                  <div class="frwds scndhalfs vcenter">
                    <div class="tabcell">
                      Acciones
                    </div>
                  </div>
                </div>
                <div class="basicrow" *ngFor="let adminUser of this.adminUsers; let i = index"
                  [ngClass]="{'': this.isOdd(i)!=1,' bg-gray':  this.isOdd(i)==1}">
                  <div class="tab-cbar">
                    <div class="tab-cbar" [ngClass]="{'': this.isOdd(i)!=1,' bg-gray':  this.isOdd(i)==1}">
                      <div class="frwds frsthalf rline vcenter">
                        <div class="tabcell">
                          {{(adminUser.name).replace('undefined','')}}
                          {{(adminUser.lastname).replace('undefined','')}}
                        </div>
                      </div>
                      <div class="frwds frsthalf rline vcenter">
                        <div class="tabcell">
                          {{adminUser.email}}
                        </div>
                      </div>
                      <div class="frwds scndhalfs rline vcenter">
                        <div class="tabcell">
                          {{adminUser.role}}
                        </div>
                      </div>
                      <div class="frwds scndhalfs rline vcenter">
                        <div class="tabcell">
                          {{adminUser.creation_date  | date:'medium'}}
                        </div>
                      </div>
                      <div class="frwds scndhalfs vcenter">
                        <div class="tabcell">
                          <div class="actbtn" *ngIf="adminUser.id_user!=adminUser.parent">
                            <i (click)="this.edit(adminUser.name,adminUser.lastname,adminUser.email,adminUser.role,adminUser.phone_number,adminUser.id_user)"
                              class="fa fa-pencil" aria-hidden="true"></i>
                          </div>
                          <div class="actbtn" *ngIf="adminUser.id_user!=adminUser.parent">
                            <i (click)="this.delete(adminUser.id_user_fk,adminUser.id_user,adminUser.parent,adminUser.name,adminUser.lastname)"
                              class="fa fa-trash" aria-hidden="true"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- end Tabla web -->
              <!-- [INIT TABLA MOVIL] -->
              <div class="basicrow m-top-i">
                <div class="basicrow m-top visible-movil">
                  <div class="basicrow mbott-i" id="last-div">
                    <div id="myCarousel5" class="carousel slide" data-interval="false" data-ride="carousel">
                      <!-- Indicators -->
                      <!-- Wrapper for slides -->
                      <div class="carousel-inner">
                        <carousel [interval]="false">
                          <slide>
                            <div class="item active">
                              <div class="boxtbl">
                                <div class="tab-tbar">
                                  <div class="frwds frsthalf-a rline vcenter">
                                    <div class="tabcell">
                                      Nombre y Apellido
                                    </div>
                                  </div>

                                  <div class="frwds frsthalf-a rline vcenter">
                                    <div class="tabcell">
                                      Usuario/Email
                                    </div>
                                  </div>
                                </div>

                                <div class="basicrow">
                                  
                                    <div class="tab-cbar"  *ngFor="let adminUser of this.adminUsers; let i = index">
                                    <div class="frwds frsthalf-a rline vcenter">
                                      <div class="tabcell">
                                        {{adminUser.name}} {{adminUser.lastname}}
                                      </div>
                                    </div>

                                    <div class="frwds frsthalf-a vcenter">
                                      <div class="tabcell">
                                        {{adminUser.email}}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </slide>
                          <slide>
                            <div class="item">
                              <div class="boxtbl">
                                <div class="tab-tbar">
                                  <div class="frwds frsthalf-a rline vcenter">
                                    <div class="tabcell">
                                      Perfil
                                    </div>
                                  </div>

                                  <div class="frwds frsthalf-a vcenter">
                                    <div class="tabcell">
                                      Fecha Creado
                                    </div>
                                  </div>
                                </div>

                                <div class="basicrow">
                                    <div class="tab-cbar"  *ngFor="let adminUser of this.adminUsers; let i = index">
                                    <div class="frwds frsthalf-a rline vcenter">
                                      <div class="tabcell">   
                                        {{adminUser.role}}
                                      </div>
                                    </div>

                                    <div class="frwds frsthalf-a vcenter">
                                      <div class="tabcell">
                                        <span class="roboto-b">
                                          {{adminUser.creation_date  | date:'medium'}}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </slide>
                          <slide>
                            <div class="item">
                              <div class="boxtbl">
                                <div class="tab-tbar">
                                  <div class="frwds frsthalf-a rline vcenter fhextended">
                                    <div class="tabcell">
                                      Acciones
                                    </div>
                                  </div>
                                </div>
                                <div class="basicrow">
                                    <div class="tab-cbar" *ngFor="let adminUser of this.adminUsers; let i = index">
                                    <div class="frwds frsthalf-a rline vcenter fhextended">
                                      <div class="tabcell">
                                        <div class="actbtn">
                                          <i class="fa fa-pencil" aria-hidden="true"></i>
                                        </div>
                                        <div class="actbtn">
                                          <i class="fa fa-trash" aria-hidden="true"></i>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </slide>
                        </carousel>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- [END TABLA MOVIL] -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-footer></app-footer>
  </div>